var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payMent" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          staticStyle: { "border-radius": "12px" },
          attrs: {
            title: _vm.$t("data.description"),
            visible: _vm.dialogVisible,
            width: "580px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: function ($event) {
              _vm.isEdit = false
            },
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "section-title" }),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "mt-12 ml-12",
              attrs: { model: _vm.form, "label-position": "left" },
            },
            [
              _c(
                "div",
                [
                  _vm.$store.getters.curCountry.country_code === "TH"
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "mt-12",
                          attrs: {
                            label:
                              _vm.$t(
                                "merchantAccount.beneficiary_account_type"
                              ) + ":",
                            prop: "beneficiary_account_type",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.beneficiaryAccountTypeFormat(
                                  _vm.detailInfo.beneficiary_account_type
                                )
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.$store.getters.curCountry.country_code === "TH" &&
                  _vm.detailInfo.beneficiary_account_type === "PROMPTPAY"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.$t("merchantAccount.beneficiary_type") + ":",
                            prop: "beneficiary_type",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.beneficiaryTypeFormat(
                                  _vm.detailInfo.beneficiary_type
                                )
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.$store.getters.curCountry.country_code !== "TH" ||
                  _vm.detailInfo.beneficiary_account_type !== "PROMPTPAY"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.$t("merchantAccount.receiving_channel") + ":",
                            prop: "merchant_type",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.detailInfo.disbursement_channel) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("merchantAccount.beneficiary_name") + ":",
                        prop: "role_name",
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.detailInfo.disbursement_name) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.$t("merchantAccount.beneficiary_account_no") +
                          ":",
                        prop: "role_name",
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.detailInfo.disbursement_number) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("merchantAccount.short_name") + ":",
                        prop: "disbursement_short_name",
                        required: "",
                      },
                    },
                    [
                      !_vm.isEdit
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.detailInfo.disbursement_short_name)
                            ),
                          ])
                        : _c("el-input", {
                            staticClass: "from-input",
                            staticStyle: { width: "200px" },
                            attrs: {
                              maxlength: "15",
                              size: "small",
                              clearable: "",
                              "overflow:": "",
                              auto: "",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.form.disbursement_short_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "disbursement_short_name",
                                  $$v
                                )
                              },
                              expression: "form.disbursement_short_name",
                            },
                          }),
                      !_vm.isEdit
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ml-20 confirm-btn-bg",
                              attrs: { size: "small" },
                              on: { click: _vm.onClickEditShort },
                            },
                            [_vm._v(_vm._s(_vm.$t("components.edit")))]
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ml-20 confirm-btn-bg",
                              attrs: { size: "small" },
                              on: { click: _vm.onClickSubmit },
                            },
                            [_vm._v(_vm._s(_vm.$t("components.confirm")))]
                          )
                        : _vm._e(),
                      _vm.isEdit
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ml-20 cancel-btn-bg",
                              attrs: { size: "small" },
                              on: { click: _vm.cancelShortName },
                            },
                            [_vm._v(_vm._s(_vm.$t("components.cancel")))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.isGulfCountry
                    ? [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.$t("merchantAccount.beneficiary_iban") +
                                ":",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.detailInfo.iban) + " ")]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.$t(
                                  "merchantAccount.beneficiary_swift_code"
                                ) + ":",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.detailInfo.swift_code) + " "
                            ),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.$t(
                                  "merchantAccount.beneficiary_bank_address"
                                ) + ":",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.detailInfo.bank_address) + " "
                            ),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.$t(
                                  "merchantAccount.beneficiary_en_first_name"
                                ) + ":",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.detailInfo.en_first_name) + " "
                            ),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.$t(
                                  "merchantAccount.beneficiary_en_last_name"
                                ) + ":",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.detailInfo.en_last_name) + " "
                            ),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.$t(
                                  "merchantAccount.beneficiary_native_first_name"
                                ) + ":",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.detailInfo.local_first_name) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.$t(
                                  "merchantAccount.beneficiary_native_last_name"
                                ) + ":",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.detailInfo.local_last_name) + " "
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _vm.$store.getters.curCountry.country_code === "TH"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.$t("merchantAccount.beneficiary_mobile") +
                              ":",
                            prop: "beneficiary_mobile",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.detailInfo.beneficiary_mobile) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.detailInfo.expire_time && !_vm.showExpireTime
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("merchantAccount.expire_time") + ":",
                            prop: "expire_time",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.formattedDate) + " ")]
                      )
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "mt-12" },
                [
                  _c("h2", { staticClass: "font_size_title" }, [
                    _vm._v(_vm._s(_vm.$t("merchantAccount.other"))),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mt-8",
                      attrs: {
                        label: _vm.$t("data.remark") + ":",
                        prop: "remark",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "from-input",
                          staticStyle: {
                            display: "inline-block",
                            "word-break": "break-word",
                            "white-space": "pre-line",
                            "line-height": "1.5",
                            "margin-top": "7px",
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.detailInfo.remark) + " ")]
                      ),
                    ]
                  ),
                  _vm.showReviewComments
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.$t("merchantAccount.review_comments") + ":",
                            prop: "review_comments",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "from-input",
                              staticStyle: {
                                display: "inline-block",
                                "word-break": "break-word",
                                "white-space": "pre-line",
                                "line-height": "1.5",
                                "margin-top": "7px",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.detailInfo.audit_recommend) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "mt-12" },
                [
                  _c("h2", { staticClass: "font_size_title" }, [
                    _vm._v(_vm._s(_vm.$t("merchantAccount.attachments"))),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "mt-8",
                      attrs: {
                        label: _vm.$t("customerService.attachments") + ":",
                      },
                    },
                    [
                      _vm.detailInfo.contract_attachment_list
                        ? _vm._l(
                            _vm.detailInfo.contract_attachment_list,
                            function (item) {
                              return _c("div", { key: item.file_name }, [
                                _vm.isImg(item.file_name)
                                  ? _c("img", {
                                      directives: [
                                        { name: "viewer", rawName: "v-viewer" },
                                      ],
                                      staticClass:
                                        "content-img reply-content-img",
                                      attrs: {
                                        src: item.file_oss_url,
                                        alt: "",
                                      },
                                    })
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "reply-content-file",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onClickIcon(
                                              item.file_name,
                                              item.file_oss_url
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(item.file_name))]
                                    ),
                              ])
                            }
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-button",
            {
              staticClass: "btn-submit ml-12",
              attrs: { type: "info" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("Close")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }